import { YearStatisticDTO } from "../domain/models/dto/WorksStatisticDTO";
import { ApiServiceImpl, createAsyncThunkFactory } from "./ApiServiceImpl";

export class WorksStatisticServiceImpl extends ApiServiceImpl {
    private constructor() {
        super();
    }

    static getYearStatisticThunk = createAsyncThunkFactory<
        YearStatisticDTO[],
        void
    >("WorksStatisticServiceImpl.getYearStatisticThunk", async () => {
        return this.get("/api/v1/works-statistic/year", undefined, true);
    });
}
